<div *ngIf="active" class="tab-item-content">
    <ng-content></ng-content>
</div>
